var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title"},[_vm._v("存量统计(按归属)")]),_c('div',{ref:"main",staticClass:"main"})])
}
var staticRenderFns = []

export { render, staticRenderFns }